import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';

const Training = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);


  return (
    <div>
      <section className="banner">
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <h6 className="banner-subtitle">Services / Training</h6>
          <hr />
          <h1 className="banner-title">
            Empower Your Workforce with Expert-Led Training
          </h1>
          <button className="banner-button mt-3">
           Contact Us <span className="arrow">→</span>
          </button>
        </div>
        <img
          src="https://img.freepik.com/free-photo/red-shirt-group-people-business-conference-modern-classroom-daytime_146671-16291.jpg"
          alt="Banner Background"
          className="banner-image"
        />
      </section>


    <section id="about_pg" className="p_3">
        <div className="container-xl">
          <div className="row about_pg1">
            <div className="col-md-6">
              <div className="about_pg1l mt-5">
                <h6 className="col_yell">
                  Training
                </h6>
                <h2 className="mt-3 mb-3">
                  About Our Training Programs
                </h2>
                <p>
                  Our training programs are designed to empower individuals and teams with the skills and knowledge they need to excel in the fast-evolving world of technology. Whether you're looking to upskill your employees or embark on a career in software development, data analytics, or project management, we provide comprehensive, hands-on learning experiences led by industry experts.
                </p>
                <p>Join us to gain the practical knowledge and certifications that will help you drive success in today's digital-first business environment.</p>
                
              </div>
            </div>

            <div className="col-md-6">
              <div className="about_pg1r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <a href="#">
                      <img
                        src="https://img.freepik.com/free-photo/red-shirt-group-people-business-conference-modern-classroom-daytime_146671-16291.jpg"
                        className="w-100"
                        alt="Empowering Decisions"
                      />
                    </a>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>



<section id="featured_training" class="p_3 bg-light">
  <div class="container-xl">
    <h2 className="text-center mt-3">Training Programs</h2>

    <p className="text-center mb-4">Discover the latest and most in-demand training programs from our experts.</p>
    <div class="row">
      <div class="col-md-4">
        <div class="program-card p-4 shadow-sm rounded bg-light">
          <h4>Full-Stack Development Bootcamp</h4>
          <p>Master both front-end and back-end development with practical projects.</p>
          <Link to="/full-stack-development">
          <button class="btn btn-outline-primary mt-2">Learn More</button>        
          </Link>
          
        </div>
      </div>
      <div class="col-md-4">
        <div class="program-card p-4 shadow-sm rounded bg-light">
          <h4>AI & Machine Learning Essentials</h4>
          <p>Unlock the power of AI by building intelligent models and systems.</p>
          <Link to="/ai-machine-learning-essentials">
          <button class="btn btn-outline-primary mt-2">Learn More</button>
          </Link>
          
        </div>
      </div>
      <div class="col-md-4">
        <div class="program-card p-4 shadow-sm rounded bg-light">
          <h4>Data Visualization with Power BI</h4>
          <p>Create compelling dashboards to communicate data effectively.</p>
          <Link to="/data-visualization-with-powerbi-tableau"> 
          <button class="btn btn-outline-primary mt-2">Learn More</button>
          </Link>
          
        </div>
      </div>
    </div>
    
  </div>
</section>




<section id="training-page">


  <div class="container-xl mt-5">
    <h2 class="text-left mt-3">Why Choose Us?</h2>
    <p>Your Partner in Professional Growth</p>
    <div class="row text-center mt-5">
      <div class="col-md-3">
        <i class="fa fa-chalkboard-teacher fa-2x mb-3 text-primary"></i>
        <h4>Expert Trainers</h4>
        <p>Learn from industry leaders with years of experience.</p>
      </div>
      <div class="col-md-3">
        <i class="fa fa-tools fa-2x mb-3 text-primary"></i>
        <h4>Hands-On Practice</h4>
        <p>Practice real-world scenarios to enhance your skills.</p>
      </div>
      <div class="col-md-3">
        <i class="fa fa-clipboard-list fa-2x mb-3 text-primary"></i>
        <h4>Tailored Programs</h4>
        <p>Programs customized to meet your team’s specific needs.</p>
      </div>
      <div class="col-md-3">
        <i class="fa fa-award fa-2x mb-3 text-primary"></i>
        <h4>Proven Results</h4>
        <p>Boost productivity and performance with measurable results.</p>
      </div>
    </div>
  </div>
</section>





    {/* <section id="about_pg" className="p_3 bg-light">
        <div className="container-xl">
        <h2 class="text-center mt-3">Our Clients</h2>
     
          <div className="row">
            <div className="col-md-2 text-center mt-4">
              
                 <img  style={{ maxWidth: '40%', height: '40%'}}  src="https://www.datafluent.xyz/assets/img/dfa/ict.png" alt="" />
              
            </div>
            <div className="col-md-2 text-center mt-4">
              
                 <img  style={{ maxWidth: '50%', height: '50%'}}  src="https://www.datafluent.xyz/assets/img/dfa/ict.png" alt="" />
              
            </div>
            <div className="col-md-2 text-center mt-4">
              
                 <img  style={{ maxWidth: '50%', height: '50%'}}  src="https://www.datafluent.xyz/assets/img/dfa/ict.png" alt="" />
              
            </div>

            <div className="col-md-2 text-center mt-4">
              
                 <img  style={{ maxWidth: '50%', height: '50%'}}  src="https://www.datafluent.xyz/assets/img/dfa/ict.png" alt="" />
              
            </div>
            <div className="col-md-2 text-center mt-4">
              
                 <img  style={{ maxWidth: '50%', height: '50%'}}  src="https://www.datafluent.xyz/assets/img/dfa/ict.png" alt="" />
              
            </div>
            <div className="col-md-2 text-center mt-4">
              
                 <img  style={{ maxWidth: '50%', height: '50%'}}  src="https://www.datafluent.xyz/assets/img/dfa/ict.png" alt="" />
              
            </div>
            
          </div>
        </div>
    </section> */}


    
<section id="serv_h" className="p_3 mt-5">
  <div className="container-fluid" style={{ padding: 40 }}>
    <div className="row serv_h1 mb-4 text-center">
      <div className="col-md-12">
        <div className="serv_h1l">
          <h3>Our Clients</h3>
          {/* <p className="mb-0">Trusted by leading innovators worldwide.</p> */}
        </div>
      </div>
    </div>

    <div className="my-swiper-container">
      <Swiper
        modules={[]}
        spaceBetween={16}
        loop={true}
        
        breakpoints={{
          320: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 16,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 16,
          },
          1200: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
        }}
      >
       
         {/* React.js */}
        <SwiperSlide>
          <img
            src="./assets/img/ict.png"
            alt="React.js"
            style={{
              width: "120px",
              height: "80px",
              objectFit: "contain",
              margin: "auto",
            }}
          />
        </SwiperSlide>

        {/* python */}
        <SwiperSlide>
          <img
            src="https://www.datafluent.xyz/assets/img/upay.png"
            alt="upay"
            style={{
              width: "120px",
              height: "80px",
              objectFit: "contain",
              margin: "auto",
            }}
          />
        </SwiperSlide>

        <SwiperSlide>
          <img
            src="https://nextgendgtech.com/wp-content/uploads/2022/10/Ngdt-Logo-T-1-300x188.png"
            alt="Client Logo 4"
            style={{
              width: "120px",
              height: "80px",
              objectFit: "contain",
              margin: "auto",
            }}
          />
        </SwiperSlide>


        <SwiperSlide>
          <img
            src="https://www.jobplant.com.au/images/job-plant_color.png"
            alt="Client Logo 6"
            style={{
              width: "120px",
              height: "80px",
              objectFit: "contain",
              margin: "auto",
            }}
          />
        </SwiperSlide>

        <SwiperSlide>
          <img
            src="https://hive4work.co.uk/images/logo/logo.png"
            alt="Client Logo 6"
            style={{
              width: "120px",
              height: "80px",
              objectFit: "contain",
              margin: "auto",
            }}
          />
        </SwiperSlide>

        

      </Swiper>

      <div className="my-swiper-button-prev"></div>
      <div className="my-swiper-button-next"></div>
    </div>
  </div>
</section>

  



<hr />



    

      <section id="serv_h" className="">
        <div className="container-xl">
          <div
            className="row serv_h3 mt-4 pt-5 pb-5 mx-0 px-4"
            style={{ backgroundColor: "#343a40", color: "white" }}
          >
            <div className="col-md-8">
              <div className="serv_h3l">
                <h2 className="text-white">Ready to Start?</h2>
                <p className="text-white mt-3">
                  Contact us today to schedule your next training program.
                </p>
                <button className="banner-button mt-3">
            <Link to="/contact" className="text-decoration-none text-white">
              Contact Us <span className="arrow">→</span>
            </Link>
          </button>
              </div>
            </div>
            <div className="col-md-4">
              <div className="serv_h3r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <Link to="/contact">
                      <img
                        src="https://img.freepik.com/free-photo/business-meeting-office_1268-21537.jpg"
                        className="w-100"
                        alt="Mobile App Development"
                      />
                    </Link>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default  Training;
